import React, { FunctionComponent } from 'react';
import { ButtonProps } from '@material-ui/core/Button';
import buttonWithArrowStyles from './buttonWithArrowStyles';
import { MuiOverrideableProps } from '../../../type/MuiOverrideableProps';
import { ExtendButtonBaseTypeMap } from '@material-ui/core/ButtonBase/ButtonBase';
import { ButtonTypeMap } from '@material-ui/core/Button/Button';
import ButtonWithIcon from './ButtonWithIcon';

export interface IButtonWithArrowProps {
  arrowSize?: number;
  labelSize?: 'large' | 'small';
  iconClasses?: string;
}

const ButtonWithArrow: FunctionComponent<
  MuiOverrideableProps<ButtonProps, ExtendButtonBaseTypeMap<ButtonTypeMap>> & IButtonWithArrowProps
> = ({ children, className, iconSize = 48, arrowSize = 20, labelSize = 'small', iconClasses, ...props }) => {
  const styles = buttonWithArrowStyles({ ...props, arrowSize, labelSize });

  return (
    <ButtonWithIcon
      {...props}
      iconSize={iconSize}
      className={[className, styles.root].join(' ')}
      iconClasses={iconClasses ? [iconClasses, styles.arrow].join(' ') : styles.arrow}
      labelClasses={styles.label}
    >
      {children}
    </ButtonWithIcon>
  );
};

export default ButtonWithArrow;
